import axios from "axios";
import { startProgress, stopProgress } from "../components/PageLoader";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const TOKEN_KEY = "brivo_token";
export const USER_KEY = "brivo_user";
export const TENANT_KEY = "brivo_tenant";

export function getToken() { return localStorage.getItem(TOKEN_KEY); }
export function getUser() {
  try { return JSON.parse(localStorage.getItem(USER_KEY) || "null"); } catch { return null; }
}
export function getTenant() {
  try { return JSON.parse(localStorage.getItem(TENANT_KEY) || "null"); } catch { return null; }
}
export function setSession({ token, user, tenant }) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  if (user) localStorage.setItem(USER_KEY, JSON.stringify(user));
  if (tenant !== undefined) localStorage.setItem(TENANT_KEY, JSON.stringify(tenant));
}
export function clearSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  localStorage.removeItem(TENANT_KEY);
}

export const authHeaders = () => {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

// ---- Global axios interceptors: progress bar + auth header pass-through ----
// Applied once at module load. Covers BOTH the `api` instance below and
// every file in the codebase that imports raw `axios`.
if (!axios.__brivoBound) {
  axios.__brivoBound = true;
  axios.interceptors.request.use((cfg) => {
    try { startProgress(); } catch { /* noop */ }
    return cfg;
  }, (err) => {
    try { stopProgress(); } catch { /* noop */ }
    return Promise.reject(err);
  });
  axios.interceptors.response.use((res) => {
    try { stopProgress(); } catch { /* noop */ }
    return res;
  }, (err) => {
    try { stopProgress(); } catch { /* noop */ }
    return Promise.reject(err);
  });
}

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  try { startProgress(); } catch { /* noop */ }
  return cfg;
}, (err) => {
  try { stopProgress(); } catch { /* noop */ }
  return Promise.reject(err);
});
api.interceptors.response.use((res) => {
  try { stopProgress(); } catch { /* noop */ }
  return res;
}, (err) => {
  try { stopProgress(); } catch { /* noop */ }
  return Promise.reject(err);
});
